<template>
  <div class="panel login-panel">
    <div class="header-content">
      <a href="https://quickreceipts.co"><img src="@/assets/img/logo-auth.png" alt="" /></a>
    </div>
    <div class="content-container">
      <card class="login-panel-content">
        <p class="text-center"><strong>Forgot Password</strong></p>
        <p class="text-center"><small>We'll check for an account under your email and<br/> send you a password reset link</small></p>
        <form @submit.prevent>
          <div class="form-group">
            <fg-input type="text"
                      placeholder="Email"
                      v-model="form.email">
            </fg-input>
          </div>
          <p-button nativeType="submit" type="success" block @click.native="onSubmit" :disabled="hasError() || loading || processing" :loading="loading || processing">
            <template v-if="!success">Send Reset Email</template>
            <template v-else>Redireting...</template>
          </p-button>
          <p v-show="error" class="error text-danger">{{error}}</p>
        </form>
      </card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      form: {
        email: '',
        error: {
          email: true,
        }
      },
      processing: false,
      success: false
    }
  },
  watch: {
    form: {
      handler() {
        this.validate()
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'error',
      'loading',
    ])
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()
      if (!this.hasError()) {
        const {error, ...payload} = this.form
        this.processing = true
        this.$store.dispatch('resetPasswordRequest', payload).then(() => {
          this.success = true
          this.$bvToast.toast('Password Reset Email sent successfully.', {
            title: `Auth`,
            variant: 'custom',
            autoHideDelay: 2000,
            solid: true
          })
          setTimeout(() => {
            this.processing = false
            this.$router.push('/login')
          }, 2000)
        }).catch(() => {
          this.processing = false
        })
      }
    },
    validate() {
      this.form.error.email = !this.form.email
    },
    hasError() {
      return Object.keys(this.form.error).some((key) => this.form.error[key])
    }
  }
}
</script>
